import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { trackWallCta } from "@/lib/mixpanel";

export const LEGALIX_SITE_URL = "https://legalix.ai";
export const LEGALIX_SUPPORT_PHONE = "+972 55-213-6446";
export const LEGALIX_SUPPORT_EMAIL = "grembek@legalix.ai";

type InsufficientCreditsDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  wall?: string;
  quotaWindowEndsAt?: string | null;
};

export const InsufficientCreditsDialog = ({
  open,
  onOpenChange,
  title = "אין מספיק קרדיטים",
  description = "פנו אלינו להשלמת יתרה או לרכישת קרדיטים.",
  wall,
  quotaWindowEndsAt,
}: InsufficientCreditsDialogProps) => {
  const windowLabel = quotaWindowEndsAt
    ? new Date(quotaWindowEndsAt).toLocaleString("he-IL")
    : null;
  const handleCta = (cta: "site" | "phone" | "email") => {
    trackWallCta({ cta, wall, surface: "web", ui: "dialog" });
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" showCloseButton>
        <div dir="rtl" className="space-y-3 text-right">
          <DialogHeader className="text-right sm:text-right">
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
            {windowLabel ? (
              <p className="text-sm text-muted-foreground">
                החלון מתמלא מחדש ב-{windowLabel}
              </p>
            ) : null}
          </DialogHeader>
          <div className="space-y-1 text-sm">
            <p>
              אתר:{" "}
              <a
                href={LEGALIX_SITE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-medium"
                onClick={() => handleCta("site")}
              >
                {LEGALIX_SITE_URL}
              </a>
            </p>
            <p>Legalix</p>
            <p>
              <a
                href="tel:+972552136446"
                className="underline"
                dir="ltr"
                onClick={() => handleCta("phone")}
              >
                {LEGALIX_SUPPORT_PHONE}
              </a>
            </p>
            <p>
              email{" "}
              <a
                href={`mailto:${LEGALIX_SUPPORT_EMAIL}`}
                className="underline"
                dir="ltr"
                onClick={() => handleCta("email")}
              >
                {LEGALIX_SUPPORT_EMAIL}
              </a>
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InsufficientCreditsDialog;
